import { Button } from '@mui/material';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  && {
    background-color: #284b31;
    &:hover {
      background-color: #1f3a26;
    }
    margin-right: 2%;
  }
`;
